import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton'
import _ from 'lodash'

const Loader = (props: { length: number; fullHeight?: boolean }) => {
    return (
        <Stack sx={{ width: '100%', height: props.fullHeight ? '100%' : 'auto' }} gap={1}>
            {_.fill(Array(props.length), 0).map((item, index) => (
                <Skeleton key={`resource-loader${index}`} height={props.fullHeight ? '100%' : 100} />
            ))}
        </Stack>
    )
}

export default Loader
